import { Label, useDropDownValueMultiple } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { DropDownValueMultipleProps as Props } from './types';

export const DropDownValueMultiple = memo(
  ({ className, selectedOptions }: Props) => {
    const { text, extra } = useDropDownValueMultiple(selectedOptions);

    return (
      <Styled.Wrapper
        className={classnames('DropDownValueMultiple', className)}
        sx={SX.root}
      >
        <Box sx={SX.box}>
          <Typography lineHeight={1} fontWeight={600} variant="body3">
            {text}
          </Typography>
        </Box>
        <Box sx={SX.box}>
          {extra > 0 && (
            <Label color="primary" variant="filled">
              +{extra}
            </Label>
          )}
        </Box>
      </Styled.Wrapper>
    );
  }
);

DropDownValueMultiple.displayName = 'DropDownValueMultiple';
